import React from "react";
import {Col, Nav, NavItem, NavLink, Row,} from "reactstrap";
import classnames from "classnames";
import "./tabcomponent.css";

const TabComponent = (props) => {

    const oneOnOneClassNames = classnames("nav-padding-16",{active: props.activeTab === "onetoone", "cursor-pointer": true});
    const groupClassNames = classnames("nav-padding-16",{active: props.activeTab === "group", "cursor-pointer": true});

    return (
        <Row>
            <Col md="12">
                <Nav tabs className="availability-requests">
                    <NavItem className="mx-4 width-40 ">
                        <NavLink
                            className={oneOnOneClassNames}
                            onClick={() => props.toggle("onetoone")}>
                            1-ON-1
                            ({props.oneToOneRequestCount})
                        </NavLink>
                    </NavItem>
                    <NavItem className="ml-md-3 width-40 ">
                        <NavLink
                            className={groupClassNames}
                            onClick={() => props.toggle("group")}>
                            GROUP
                            ({props.groupRequestCount})
                        </NavLink>
                    </NavItem>
                </Nav>
            </Col>
        </Row>
    )
};

export default TabComponent;